// extracted by extract-css-chunks-webpack-plugin
module.exports = {"video":"css-19pHxhjqKw"};